import { GetNoteListRequest, GetNoteSingleItemRequest, PutNoteRequest } from '@finance-lab/utils/types'
import ApiBase from './Api'

export type NoteEntityRef =
    | { issueId: string; convertibleId?: never; warrantId?: never }
    | { convertibleId: string; issueId?: never; warrantId?: never }
    | { warrantId: string; issueId?: never; convertibleId?: never }

const NOTES_API_PATHS = {
    NOTES: '/notes',
    NOTE: (entityId: string) => `/notes/${entityId}`,
}

const getEntityId = (entityRef: NoteEntityRef): string => {
    if ('issueId' in entityRef && entityRef.issueId) {
        return entityRef.issueId
    }
    if ('convertibleId' in entityRef && entityRef.convertibleId) {
        return entityRef.convertibleId
    }
    if ('warrantId' in entityRef && entityRef.warrantId) {
        return entityRef.warrantId
    }
    throw new Error('Exactly one entity id must be provided.')
}

export class NotesApi extends ApiBase {
    async listNotes() {
        return this._getRequest<GetNoteListRequest>(NOTES_API_PATHS.NOTES)
    }

    async getNote(entityRef: NoteEntityRef) {
        return this._getRequest<GetNoteSingleItemRequest>(NOTES_API_PATHS.NOTE(getEntityId(entityRef)))
    }

    async saveNote(entityRef: NoteEntityRef, content: string | null) {
        const entityId = getEntityId(entityRef)
        return this._putRequest<PutNoteRequest>(NOTES_API_PATHS.NOTE(entityId), { ...entityRef, content })
    }

    async deleteNote(entityRef: NoteEntityRef) {
        return this._deleteRequest(NOTES_API_PATHS.NOTE(getEntityId(entityRef)))
    }
}
